import { Component } from "@angular/core";

@Component({
        standalone: false,
    templateUrl: "./privacy-policy.component.html",
    styleUrls: ["./privacy-policy.component.css"]
})
export class PrivacyPolicyPage {}
